import { render } from "./SettingsOrders.vue?vue&type=template&id=6b3e9e1c&scoped=true"
import script from "./SettingsOrders.vue?vue&type=script&lang=js"
export * from "./SettingsOrders.vue?vue&type=script&lang=js"

import "./SettingsOrders.vue?vue&type=style&index=0&id=6b3e9e1c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b3e9e1c"]])

export default __exports__